import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";

import { COMN_SF_LPCO_SRCH, COMN_SG_LPCO_LIST_HEAD, COMN_SG_LPCO_LIST_BODY } from "@/tz/go/egaz/osci/lpco/cfgn/comn";

/*
 *  Additional Item Settings
 * !== Additional Item Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${lpcoEnvs.base}/lpco/cfgn/adtnlitm`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/cfgn/adtnlitm`,
    nodes: [
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_LPCO" },
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_CFGN" },
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_LPCO_APP_SETT" },
        { path: "/lpco/cfgn/adtnlitm/osci0203005s", label: "T_ADTNL_FLD_SETT" },
    ],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0203005s: `${BASE.path}/osci0203005s`, // Register Additional Item   !== 추가 항목 등록  ==!
    osci0203006q: `${BASE.path}/osci0203006q`, // Register Additional Item List  !== 추가 항목 구성 목록 조회  ==!
    osci0203007s: `${BASE.path}/osci0203007s`, // Register Additional Item Detail  !== 추가 항목 구성 상세 조회  ==!
    osci0203008s: `${BASE.path}/osci0203008s`, // Additional Item Modification  !== 추가 항목 수정 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    /* Additional Item inquiry !== Additional Item 목록 조회 ==! */
    getLpcoList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    /* LPCO detailed inquiry !== Additional Item 상세 조회 ==! */
    getAppDtl: (appFmId: any) => {
        return api.get(`${BASE.api}/${appFmId}`);
    },
    getAppDtlByAppCdNo: (appCdNo: any) => {
        return api.get(`${BASE.api}/app-cd-no/${appCdNo}`);
    },
    /* Register LPCO information !== Additional Item 등록 ==! */
    saveAppAddItm: (data: any) => {
        return api.put(`${BASE.api}/${data.appFmId}`, {
            ...data,
        });
    },

    /* Edit LPCO information !== Additional Item 수정 ==! */
    /* Delete LPCO information !== Additional Item 삭제 ==! */
};

/*
 * @ Form 스키마 정의
 * @ 화면에서 사용하는 Form 구조 정의
 * @ SF_ 로 시작 (Schema form)
 * @ SF_[Form 이름 메타 대문자, "_" 로 구분 ]
 * @ 검색폼은 _SRCH 로 구분
 */
export const SF_LPCO_INFO_R: TFormSchema = {
    id: "form_LpcoInfo",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            controlSize: 10,
            edit: false,
        } /* OGA */,
        orgNm: { type: "text", label: "L_OGA", edit: false } /* OGA Name */,
        appCdNo: {
            type: "select",
            label: "L_LPCO",
            required: true,
            edit: false,
        } /* L_LPCO */,
        appNm: {
            type: "text",
            label: "L_LPCO",
            required: true,
            edit: false,
        } /* L_LPCO */,
        appTpCd: {
            type: "select",
            label: "L_APP_TP",
            area: "comnCd",
            comnCd: "OSC0113",
            viewType: "label",
            edit: false,
        },
    },
};

export const SF_LPCO_INFO_U: TFormSchema = {
    id: "form_LpcoInfo",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            controlSize: 10,
            edit: false,
        } /* OGA */,
        orgNm: { type: "text", label: "L_OGA", edit: false } /* OGA Name */,
        appCdNo: {
            type: "select",
            label: "L_LPCO",
            edit: true,
            required: true,
        } /* L_LPCO */,
        appNm: {
            type: "text",
            label: "L_LPCO",
            edit: false,
            controlSize: 10,
        } /* L_LPCO */,
        appTpCd: {
            type: "select",
            label: "L_APP_TP",
            area: "comnCd",
            comnCd: "OSC0113",
            viewType: "label",
            edit: false,
        },
    },
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명가 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */

// LPCO Search Schema !== LPCO Search Schema ==!
export const SF_LPCO_SRCH: TFormSchema = {
    id: "form_LpcoSrch",
    schema: {
        ...COMN_SF_LPCO_SRCH,
    },
};

// LPCO Settings List Grid Schema !== LPCO 설정 목록 그리드 스키마 ==!
export const SG_LPCO_LIST_R: TGridSchema = {
    id: "grid_lpcoList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 410,
    },
    head: [
        ...COMN_SG_LPCO_LIST_HEAD,
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: 80 }] } /* Use Yn */,
        { cells: [{ header: "L_NO_ADTNL_FLD", binding: "cnt", width: "15%" }] } /* Number of Assignment */,
    ],
    body: [
        ...COMN_SG_LPCO_LIST_BODY,
        {
            cells: [
                {
                    binding: "useYn",
                    align: "center",
                    area: "comnCd",
                    comnCd: "OSC0101",
                    type: "select",
                    viewType: "value",
                },
            ],
        },
        { cells: [{ binding: "cnt", type: "number", align: "center" }] },
    ],
};

// Additional Item Schema !== Additional Item Schema ==!
export const SG_LPCO_ADDITM_LIST_U: TGridSchema = {
    id: "grid_additmRList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: true, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: true, // 그리드 편집 가능 여부 , default : false
        height: 400,
    },
    head: [
        {
            cells: [{ header: "L_ADTNL_INFO_CD_NO", binding: "adtnlItmCdNo", width: 150 }],
        } /* Additional item code number. */,

        {
            cells: [{ header: "L_ADTNL_INFO_NM", binding: "adtnlItmNm", minWidth: "200", width: "*" }],
        } /* Additional Info. */,

        // { cells: [{ header: "L_ADTNL_INFO_KY", binding: "adtnlItmKy", width: "*" }] } /* Additional Key: ref tech. */,

        { cells: [{ header: "L_CPNT_CD", binding: "additmCpntCd", width: 150 }] } /* Area Type Code */,
        { cells: [{ header: "L_INP_TP_CD", binding: "inpTpCd", width: 200 }] } /* Input Type Code */,
        { cells: [{ header: "L_RQRD", binding: "rqrdInpYn", width: 100 }] } /* Required */,
        { cells: [{ header: "L_SRTNG_ORD", binding: "adtnlItmSrno", width: 80 }] } /* Sort Order */,
        { cells: [{ header: "L_PRNT", binding: "printYn", width: 100 }] } /* Print on report */,
        { cells: [{ header: "L_MAX_LEN", binding: "adtnlItmMaxLenVal", width: 100 }] } /* Max Length */,

        { cells: [{ header: "L_COMN_CD", binding: "comnCd", minWidth: 200, width: "*" }] } /* Common Code */,

        { cells: [{ header: "L_OPT_TB_NM", binding: "optTbNm", width: 180 }] } /* Table Name */,
        { cells: [{ header: "L_OPT_CD_COL", binding: "optColNm", width: 180 }] } /* Table Column Name */,
        { cells: [{ header: "L_OPT_CD_NM_COL", binding: "optColCn", width: 180 }] } /* Value Table Column Name */,
    ],
    body: [
        {
            cells: [
                {
                    binding: "adtnlItmCdNo",
                    type: "text",
                    edit: false,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "adtnlItmNm",
                    align: "left",
                    type: "text",
                    maxLength: 100,
                    required: true,
                },
            ],
        },
        // {
        //     cells: [
        //         {
        //             binding: "adtnlItmky",
        //             align: "left",
        //             type: "text",
        //             maxLength: 100,
        //         },
        //     ],
        // },
        {
            cells: [
                {
                    binding: "additmCpntCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0116",
                    area: "comnCd",
                    excludes: ["DCL", "ATC", "PAY", "MSG", "CON"],
                    required: true,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "inpTpCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0128",
                    area: "comnCd",
                    required: true,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "rqrdInpYn",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0100",
                    area: "comnCd",
                    required: true,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "adtnlItmSrno",
                    align: "right",
                    type: "number",
                    required: true,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "printYn",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0100",
                    area: "comnCd",
                    required: true,
                },
            ],
        },
        { cells: [{ binding: "adtnlItmMaxLenVal", align: "right", type: "number", max: 4000, maxLength: 4 }] },
        {
            cells: [
                {
                    binding: "comnCd",
                    align: "left",
                    // type: "code",
                    // area: "comnCdMstr",
                },
            ],
        },

        { cells: [{ binding: "optTbNm", align: "left", type: "text", maxLength: 100 }] },
        { cells: [{ binding: "optColNm", align: "left", type: "text", maxLength: 100 }] },
        { cells: [{ binding: "optColCn", align: "left", type: "text", maxLength: 2000 }] },
    ],
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명가 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */

// LPCO Settings List Grid Schema !== LPCO 설정 목록 그리드 스키마 ==!
/*
Additional Info. Name  L_ADTNL_INFO_NM
Area Type Code OSC0116  L_CPNT_CD
Input Type Code OSC0128 exclude PP L_INP_TP_CD
Common Code 공통코드 팝업 만들어야함. L_COMN_CD
Required    OSC0100  L_RQRD
Max Length  NUMBER L_MAX_LEN
*/

export const SG_LPCO_ADDITM_LIST_R: TGridSchema = {
    id: "grid_additmRList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 400,
    },
    head: [
        {
            cells: [{ header: "L_ADTNL_INFO_CD_NO", binding: "adtnlItmCdNo", width: 150 }],
        } /* Additional item code number. */,
        { cells: [{ header: "L_ADTNL_INFO_NM", binding: "adtnlItmNm", width: "*" }] } /* Additional Info. */,
        // { cells: [{ header: "L_ADTNL_INFO_KY", binding: "adtnlItmKy", width: "*" }] } /* Additional Key: ref tech. */,

        { cells: [{ header: "L_CPNT_CD", binding: "additmCpntCd", width: 150 }] } /* Area Type Code */,
        { cells: [{ header: "L_INP_TP_CD", binding: "inpTpCd", width: 200 }] } /* Input Type Code */,
        { cells: [{ header: "L_RQRD", binding: "rqrdInpYn", width: 100 }] } /* Required */,
        { cells: [{ header: "L_SRTNG_ORD", binding: "adtnlItmSrno", width: 150 }] } /* Sort Order */,
        { cells: [{ header: "L_PRNT", binding: "printYn", width: 100 }] } /* Print on report */,
        { cells: [{ header: "L_MAX_LEN", binding: "adtnlItmMaxLenVal", width: 100 }] } /* Max Length */,

        { cells: [{ header: "L_COMN_CD", binding: "comnCd", width: 200 }] } /* Common Code */,

        { cells: [{ header: "L_OPT_TB_NM", binding: "optTbNm", width: 180 }] } /* Table Name */,
        { cells: [{ header: "L_OPT_CD_COL", binding: "optColNm", width: 180 }] } /* Table Column Name */,
        { cells: [{ header: "L_OPT_CD_NM_COL", binding: "optColCn", width: 180 }] } /* Value Table Column Name */,
    ],
    body: [
        {
            cells: [
                {
                    binding: "adtnlItmCdNo",
                    type: "text",
                    edit: false,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "adtnlItmNm",
                    align: "left",
                    type: "text",
                    maxLength: 100,
                    required: true,
                },
            ],
        },
        // {
        //     cells: [
        //         {
        //             binding: "adtnlItmKy",
        //             align: "left",
        //             type: "text",
        //             maxLength: 100,
        //         },
        //     ],
        // },
        {
            cells: [
                {
                    binding: "additmCpntCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0116",
                    area: "comnCd",
                    excludes: ["DCL", "ATC", "PAY", "MSG", "CON"],
                    required: true,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "inpTpCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0128",
                    area: "comnCd",
                    required: true,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "rqrdInpYn",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0100",
                    area: "comnCd",
                    required: true,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "adtnlItmSrno",
                    align: "right",
                    type: "number",
                    required: true,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "printYn",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0100",
                    area: "comnCd",
                    required: true,
                },
            ],
        },
        { cells: [{ binding: "adtnlItmMaxLenVal", align: "left", type: "number" }] },
        {
            cells: [
                {
                    binding: "comnCd",
                    align: "left",
                    type: "select",
                },
            ],
        },

        { cells: [{ binding: "optTbNm", align: "left", type: "text" }] },
        { cells: [{ binding: "optColNm", align: "left", type: "text" }] },
        { cells: [{ binding: "optColCn", align: "left", type: "text" }] },
    ],
};
